import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import userStore from '../Stores/User';

export const usePendingActions = () => {
  const history = useHistory();

  useEffect(() => {
    // Only run when user is signed in
    if (!userStore.isSignedIn) return;

    // Check for pending coupon
    const pendingCoupon = localStorage.getItem('pendingCoupon');
    if (pendingCoupon) {
      try {
        const couponData = JSON.parse(pendingCoupon);
        localStorage.removeItem('pendingCoupon');
        
        // Redirect to the intended URL with coupon
        if (couponData.returnUrl) {
          history.push(couponData.returnUrl);
        }
      } catch (error) {
        console.error('Error handling pending coupon:', error);
        localStorage.removeItem('pendingCoupon');
      }
    }

    // Check for pending referral
    const pendingReferral = localStorage.getItem('pendingReferral');
    if (pendingReferral) {
      try {
        const referralData = JSON.parse(pendingReferral);
        localStorage.removeItem('pendingReferral');
        
        // Redirect to the intended URL with referral
        if (referralData.returnUrl) {
          history.push(referralData.returnUrl);
        }
      } catch (error) {
        console.error('Error handling pending referral:', error);
        localStorage.removeItem('pendingReferral');
      }
    }
  }, [userStore.isSignedIn, history]);
};
